import { GetStaticProps } from 'next';
import React from 'react';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import Header from '@components/organisms/header';
import Component500 from '@components/templates/errorPage/500';

type Params = {
  locale: string;
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context as Params;

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};

const Page500NotFound = () => {
  return (
    <>
      <Header />
      <Component500 />
    </>
  );
};

export default Page500NotFound;
